import styles from './voice.module.css';
import DOMPurify from 'dompurify';
const Voice = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_722_2459)">
            <path
              d="M15.704 42.6661H5.33329C4.62605 42.6661 3.94777 42.3851 3.44767 41.885C2.94758 41.3849 2.66663 40.7066 2.66663 39.9994V23.9994C2.66663 23.2922 2.94758 22.6139 3.44767 22.1138C3.94777 21.6137 4.62605 21.3327 5.33329 21.3327H15.704L29.8213 9.78074C30.0166 9.6206 30.2534 9.51924 30.5041 9.48845C30.7548 9.45767 31.0091 9.49874 31.2374 9.60687C31.4657 9.715 31.6585 9.88574 31.7935 10.0992C31.9285 10.3127 32.0001 10.5602 32 10.8127V53.1861C32.0001 53.4387 31.9285 53.6861 31.7935 53.8996C31.6585 54.1131 31.4657 54.2838 31.2374 54.3919C31.0091 54.5001 30.7548 54.5411 30.5041 54.5104C30.2534 54.4796 30.0166 54.3782 29.8213 54.2181L15.7066 42.6661H15.704Z"
              fill="#FF6B4D"
            />
            <g opacity="0.4">
              <path
                d="M47.9733 49.9155L51.7493 53.6915C57.6373 48.3261 61.3333 40.5955 61.3333 32.0008C61.3375 27.7435 60.413 23.5366 58.6241 19.6733C56.8353 15.8101 54.2252 12.3836 50.976 9.63281L47.1893 13.4195C49.9455 15.6681 52.1663 18.5024 53.6903 21.7165C55.2143 24.9305 56.0033 28.4437 56 32.0008C56.004 35.3845 55.2908 38.7307 53.9072 41.8186C52.5236 44.9066 50.5012 47.6662 47.9733 49.9155Z"
                fill="#FF6B4D"
              />
              <path
                d="M38.5093 40.4515L42.3013 44.2435C45.7867 41.3075 48 36.9128 48 32.0008C48.0021 29.4933 47.414 27.0205 46.2831 24.7825C45.1523 22.5444 43.5105 20.604 41.4907 19.1181L37.6533 22.9555C40.6667 24.8408 42.6667 28.1875 42.6667 32.0008C42.6681 33.6339 42.294 35.2454 41.5731 36.7108C40.8522 38.1761 39.8039 39.456 38.5093 40.4515Z"
                fill="#FF6B4D"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_722_2459">
              <rect width="64" height="64" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text27']),
          }}
        ></h1>

        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text28']),
          }}
        ></h5>
      </div>

      <video
        loop
        autoPlay
        playsInline
        muted
        preload="true"
        src="http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-sound.mp4"
        poster='http://zhiyun-website-shenzhen.oss-cn-shenzhen.aliyuncs.com/detail/ozone-speaker/zhiyunlife-ozonespeaker-sound-cover.jpg'
      ></video>
      <div className={styles.mask}></div>
    </div>
  );
};

export default Voice;
